import { api } from '../core';

export type DocumentProviderAddUnassignedResponse = object;

type DocumentProviderAddUnassignedProps = {
  providerId: string;
  documentIds: string[];
  unassignedDocumentIds: string[];
};

const documentProviderAddUnassignedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentProviderAddUnassigned: builder.query<
      DocumentProviderAddUnassignedResponse,
      DocumentProviderAddUnassignedProps
    >({
      query: ({ providerId, documentIds, unassignedDocumentIds }: DocumentProviderAddUnassignedProps) => ({
        url: `document/provider/add/unassigned`,
        method: 'POST',
        body: {
          providerId: providerId,
          documentIds: documentIds,
          unassignedDocumentIds: unassignedDocumentIds
        }
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error('Error in postDocumentProviderAddUnassigned in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentProviderAddUnassignedQuery } = documentProviderAddUnassignedApi;
